import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CommonField } from '../../../models/Field';

@Component({
  selector: 'error-box',
  template: `<div
    *ngIf="control.invalid && control.touched && control.errors"
    [style.width]="field.size ? field.size + 'em' : ''"
    style="padding: 0.1em 0 0;"
  >
    <div class="text-left" *ngFor="let errKey of errorKeys" style="color: red;">
      {{
        field.rules[errKey] && field.rules[errKey].message
          ? field.rules[errKey].message
          : errKey
      }}
    </div>
  </div>`,
})
export class ErrorBoxComponent {
  @Input() form: FormGroup;
  @Input() field: CommonField;

  get control() {
    return this.form.controls[this.field.key];
  }
  get errorKeys() {
    return Object.keys(this.control.errors);
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/components/fields/validation-info/error-box.component.ts